






















































































































































































import Vue from "vue";
import { MFA_TOTP, MFA_EMAIL, MFA_SMS } from "@/services/types/mfa.type";
import { RESET_PASSWORD_SETTING } from "@/services/types/resetPassword.type";
import router from "@/router";
import identityAuthenClient from "@/services/identityAuthenClient";
import userInfoProvider from "@/services/userInfoProvider";

import {
  LOWER_CASE_REGEX,
  STRING_CONTAIN_NUMBER_REGEX,
  UPPER_CASE_REGEX,
} from "@/constant/regex";
import { TOTP } from "@/services/types/login.type";

export default Vue.extend({
  name: "AuthenticationManagement",
  components: {},
  data() {
    const self: any = this;
    return {
      accessToken: '',
      showNoti: false,
      messageNoti: "",
      form: false,
      error: "",
      isWaiting: false,
      passwordCondition: {
        length: false,
        numberCharacter: false,
        leterCase: false,
      },
      matchPassword: null as any,
      formValue: {
        loginName: "",
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      dirty: false,
      confirmPasswordDirty: false,
      rules: {
        required: (value) => {
          return !!value || "Required";
        },
        newPassword: (value) => {
          return self.doneTypingNewPassword() || "invalid";
        },
        comparePassword: (value) => {
          return self.comparePassword() || "Not match";
        },
      },
      RESET_PASSWORD_SETTING,
    };
  },
  created() {
    this.accessToken = userInfoProvider.getAccessToken();
  },
  methods: {
    goBack() {
      router.push({ name: "username-password" });
    },
    clear() {
      this.messageNoti = ""
      this.formValue = {
        loginName: "",
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
    },
    focusConfirmPassword() {
      this.confirmPasswordDirty = true;
    },
    doneTypingNewPassword() {
      let valid: any = true;
      if (this.formValue.newPassword.length >= 8) {
        this.passwordCondition.length = true;
      } else {
        this.passwordCondition.length = false;
        valid = false;
      }

      if (STRING_CONTAIN_NUMBER_REGEX.test(this.formValue.newPassword)) {
        this.passwordCondition.numberCharacter = true;
      } else {
        this.passwordCondition.numberCharacter = false;
        valid = false;
      }

      if (
        this.formValue.newPassword.match(LOWER_CASE_REGEX) &&
        this.formValue.newPassword.match(UPPER_CASE_REGEX)
      ) {
        this.passwordCondition.leterCase = true;
      } else {
        this.passwordCondition.leterCase = false;
        valid = false;
      }
      return valid;
    },
    comparePassword() {
      if (this.dirty && this.confirmPasswordDirty) {
        if (this.formValue.newPassword === this.formValue.confirmPassword) {
          this.matchPassword = true;
          return true;
        }
        this.matchPassword = false;
        return false;
      }
      return true;
    },
    validateAll(event) {
      (this.$refs.form as any).validate();

      // If key is enter
      if (event.which === 13 || event.keyCode === 13) {
        if (this.form) {
          this.changePassword();
        }
      }
    },
    async changePassword() {
      this.isWaiting = true;
      let query: any;
      query = {
        oldPassword: this.formValue.oldPassword,
        newPassword: this.formValue.newPassword,
        type: RESET_PASSWORD_SETTING,
      };
      if (this.formValue.loginName) {
        query.loginName = this.formValue.loginName
      }

      try {
        const data = await identityAuthenClient.resetPassword(query);
        const errorInfo = data.error_info;
        if (errorInfo && errorInfo.message !== "" && Object.keys(errorInfo).length) {
          this.error = errorInfo.message;
          this.messageNoti = errorInfo.message;
          this.showNoti = true;
          setTimeout(() => {
            this.showNoti = false;
          }, 5000);
          this.isWaiting = false;
          return;
        }
        this.messageNoti = "Password changed successfully!";
        this.showNoti = true;
        this.formValue = {
          loginName: "",
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        },
        this.matchPassword = null;
        setTimeout(() => {
          this.showNoti = false;
        }, 5000);
        this.isWaiting = false;
      } catch (error) {
        this.error = error;
        this.messageNoti = "Password changed failed!";
        this.showNoti = true;
        setTimeout(() => {
          this.showNoti = false;
        }, 5000);
        this.isWaiting = false;
      }
    },
    goToLogin() {
      router.push({ name: "login" });
    },
  },
  watch: {
    formValue: {
      handler(newVal, oldVal) {
        this.dirty = true;
      },
      deep: true,
    },
  },
});
